import debug from 'bows';
import $ from 'jquery';

const log = debug('site:layout:accordion');

class Accordion {
	constructor(node) {
		this.node = node;
		this.$node = $(node);
		this.activeClass = 'flex-layout--accordion__panel--active';
		this.duration = 200;

		this.$panels = this.$node.find('.flex-layout--accordion__panel');
		this.$titles = this.$node.find('.flex-layout--accordion__panel__title');
		this.$contents = this.$node.find('.flex-layout--accordion__panel__content');

		this.$node.on('click', '.flex-layout--accordion__panel__title', (e) => {
			e.preventDefault();

			const $title = $(e.target);
			const $panel = $title.closest('.flex-layout--accordion__panel');
			const $content = $panel.find('.flex-layout--accordion__panel__content');

			if ( $panel.hasClass( this.activeClass ) ) {
				$content.slideUp( this.duration, () => {
					$panel.removeClass( this.activeClass );
					$content.css('display', '');
				} );
			} else {
				$content.slideDown( this.duration, () => {
					$panel.addClass( this.activeClass );
					$content.css('display', '');
				} );
			}
		});

		if ( window.location.hash ) {
			for( let i = 0; i < this.$titles.length; i++ ) {
				log( this.$titles[i].hash, window.location.hash );
				if ( this.$titles[i].hash === window.location.hash ) {
					let $panel = this.$panels.eq(i);
					$panel.addClass( this.activeClass );
					this.$contents.eq(i).css( 'display', '' );

					window.scrollTo(0, $panel.offset().top - 50 );
					break;
				}
			}
		}
	}
}

export default Accordion;
